export default __webpack_public_path__ + "static/media/smartphone.fee7767b.svg";